<template>
  <div class="checkup" v-if="checkup">
    <T8x :checkup="checkup" v-if="checkup.deviceType === 'T8X'"></T8x>
    <Gs2 :checkup="checkup" v-else></Gs2>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import T8x from '@/components/Checkups/T8x'
import Gs2 from '@/components/Checkups/Gs2'
export default {
  components: {
    T8x,
    Gs2
  },
  props: {
    checkupId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      checkupById: 'checkup/byId',
      t8xById: 'checkup/t8xById',
      gs2ById: 'checkup/gs2ById'
    }),
    checkup () {
      const checkup = this.checkupById(this.checkupId)
      if (checkup && checkup.deviceType === 'T8X') {
        return this.t8xById(this.checkupId)
      } else {
        return this.gs2ById(this.checkupId)
      }
    }
  },
  mounted () {
    this.fetch(this.checkupId)
  },
  destroyed () {
    this.resetHead()
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setCheckup: 'checkup/set',
      setT8x: 'checkup/setT8x',
      setGs2: 'checkup/setGs2',
      resetHead: 'head/reset'
    }),
    async fetch (id) {
      // const checkup = this.checkupById(id)
      // if (checkup) {
      //   return
      // }
      try {
        const response = await this.axios.get(`/device/checkups/${id}`)
        const checkup = response.data.data
        if (checkup.device_type === 'T8X') {
          this.setT8x({
            MachineId: checkup.checkup.MachineId,
            MacAddr: checkup.checkup.MacAddr,
            UnitNo: checkup.checkup.UnitNo,
            UnitName: checkup.checkup.UnitName,
            doctor_id: checkup.checkup.doctor_id,
            DoctorName: checkup.checkup.DoctorName,
            RecordNo: checkup.checkup.RecordNo,
            MeasureTime: checkup.checkup.MeasureTime,
            LoginType: checkup.checkup.LoginType,
            DeviceType: checkup.checkup.DeviceType,
            Member: checkup.checkup.Member,
            Height: checkup.checkup.Height,
            Fat: checkup.checkup.Fat,
            MinFat: checkup.checkup.MinFat,
            BloodPressure: checkup.checkup.BloodPressure,
            Bo: checkup.checkup.Bo,
            PEEcg: checkup.checkup.PEEcg,
            Temperature: checkup.checkup.Temperature,
            Whr: checkup.checkup.Whr,
            BloodSugar: checkup.checkup.BloodSugar,
            Ua: checkup.checkup.Ua,
            Chol: checkup.checkup.Chol,
            BloodFat: checkup.checkup.BloodFat,
            ArteryAve: checkup.checkup.ArteryAve,
            interview_id: checkup.checkup.interview_id,
            userId: checkup.checkup.user_id
          })
        } else {
          this.setGs2({
            MachineID: checkup.checkup.MachineID,
            MacAddr: checkup.checkup.MacAddr,
            RecordNo: checkup.checkup.RecordNo,
            MeasureTime: checkup.checkup.MeasureTime,
            DeviceType: checkup.checkup.DeviceType,
            Member: checkup.checkup.Member,
            Height: checkup.checkup.Height,
            BloodPressure: checkup.checkup.BloodPressure,
            Bo: checkup.checkup.Bo,
            Temperature: checkup.checkup.Temperature,
            Whr: checkup.checkup.Whr,
            BloodSugar: checkup.checkup.BloodSugar,
            Ua: checkup.checkup.Ua,
            Chol: checkup.checkup.Chol,
            Urinalysis: checkup.checkup.Urinalysis,
            Hb: checkup.checkup.Hb,
            Vision: checkup.checkup.Vision,
            Tooth: checkup.checkup.Tooth,
            PEEcg: checkup.checkup.PEEcg,
            Ultrasonic: checkup.checkup.Ultrasonic,
            PsychologicalAssessment: checkup.checkup.PsychologicalAssessment,
            created_at: checkup.checkup.created_at,
            UserID: checkup.checkup.UserID,
            interview_id: checkup.checkup.interview_id
          })
        }
        this.setCheckup({
          RecordNo: checkup.record_no,
          deviceType: checkup.device_type,
          userId: checkup.user_id,
          created_at: checkup.created_at,
          sections: checkup.sections
        })
        this.loading = false
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    }
  }
}
</script>
<style lang="scss">
.checkup {
  h2 {
    font-size: 1.5em;
  }
  font-size: 0.75em;
}
</style>
<i18n>
{
  "ka": {
      "checkup": "ექსპერს სკრინინგი",
      "measurementResults": "გაზომვების შედეგები",
      "name": "სახელი",
      "gender": "სქესი",
      "age": "ასაკი",
      "phone": "ტელეფონი",
      "male": "მამრ.",
      "female":"მდედრ.",
      "id_number": "პირადი ნომერი",
      "recordNumber": "რეპორტის ნომერი",
      "recordTime": "გაზომვის დრო",
      "parameter": "მაჩვენებელი",
      "result": "შედეგი",
      "range": "ნორმის დიაპაზონი",
      "evaluation": "შეფასება",
      "height": "სიმაღლე",
      "weight": "წონა",
      "bmi": "BMI",
      "fat": "ცხიმის მაჩვენებელი",
      "waistline": "წელი",
      "hip": "თეძო",
      "waistline/hip": "წელის და თეძოს შეფარდება",
      "pulse":"პულსი",
      "highPressure":"სისტოლური წნევა",
      "lowPressure":"დიასტოლური წნევა",
      "bloodSugar1": "გლუკოზა სისხლში (უზმოდ)",
      "bloodSugar2": "გლუკოზა სისხლში (კვების  შემდეგ)",
      "bloodSugar3": "გლუკოზა სისხლში",
      "ua": "შარდმჟავა",
      "totalChol": "საერთო ქოლესტერინი",
      "totalCholL": "საერთო ქოლესტერინი L",
      "HDLChol": "HDL ქოლესტერინი",
      "LDLChol": "LDL ქოლესტერინი",
      "trig": "ტრიგლიცერიდები",
      "bloodOxygen": "სისხლის ჟანგბადი",
      "temperature": "Სხეულის ტემპერატურა",
      "bodyContents": "სხეულის შემადგენლობა",
      "weightAnalysis": "ცხიმიანობის ანალიზი",
      "fatRate": "სხეულის ცხიმის პროცენტი",
      "bodyFat": "სხეულის ცხიმოვანი მასა",
      "Muscle": "კუნთის მასა",
      "WaterRate": "წყლის დონე სხეულში",
      "bodyType": "სხეულის ტიპის შეფასება",
      "idealWeight": "იდეალური წონა",
      "WeightAdjust": "წონის რეგულირება",
      "FatAdjust": "ცხიმის რეგულირება",
      "MuscleAdjust": "კუნთების რეგულირება",
      "bodyContentsAnalysis": "სხეულის შემადგენლობის ანალიზი",
      "ExceptFat": "უცხიმო მასა",
      "Protein": "ცილა",
      "Foc": "უჯრედგარე სითხე",
      "Water": "სხეულის წყლის მასა",
      "Bmc": "ძვლის მასა",
      "Fic": "უჯრედშიდა სითხე",
      "fatMass": "ცხიმის მასა",
      "bodyFat": "სხეულის ცხიმის მასა",
      "BasicMetabolism": "ბაზალური მეტაბოლიზმი",
      "Standard": "სტანდარტული",
      "leftArm": "Მარცხენა მკლავი",
      "leftLeg": "Მარცხენა ფეხი",
      "rightArm": "მარჯვენა მკლავი",
      "rightLeg": "მარჯვენა ფეხი",
      "Qugan": "ტორსი",
      "ecg": "ელექტროკარდიოგრამა",
      "symptomCheckerResult": "შევსებული სიმპტომები"
  }
}
</i18n>
